import React from "react";
import Select from 'react-select'
class FormWizard extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="uk-margin">
        { this.renderLabel() }
        { this.renderInputField() }

        { this.renderError() }
      </div>
    )
  }

  renderInputField() {
    // TODO: remove some of this duplication
    switch(this.props.type) {
      case "string":
        return (
          <input className={this.props.error ? "uk-form-danger uk-input" : "uk-input"} name={this.props.name} placeholder={this.props.placeholder} value={this.props.object[this.props.name]}
            onChange={ this.props.handleChange(this.props.name) } />
        )
        break;
      case "textarea":
        return (
          <textarea rows="5" className={this.props.error ? "uk-form-danger uk-textarea" : "uk-textarea"} name={this.props.name} placeholder={this.props.placeholder} value={this.props.object[this.props.name]}
            onChange={ this.props.handleChange(this.props.name) } />
        )
        break;
      case "react-select":
        const colourStyles = {
          control: styles => ({ ...styles, borderColor: '#0070b9 !important', borderRadius: 0 }),
        };
        return (
          <Select onChange={ this.props.handleReactSelectChange(this.props.name) } options={this.props.options} placeholder={this.props.placeholder} styles={colourStyles}/>
        )
      case "select":
        return (
          <select className="uk-select" value={this.props.object[this.props.name]} onChange={ this.props.handleChange(this.props.name) }>
            { this.renderSelectDefault() }
            { this.renderSelectOptions() }
          </select>
        )
    }
  }

  renderSelectOptions() {
    // TODO: allow for option label and value to be different
    if (this.props.options) {
      return (
        this.props.options.map((option) => <option value={option}>{option}</option>)
      )
    }
  }

  renderSelectDefault() {
    if (this.props.placeholder) {
      return (
        <option value="">{this.props.placeholder}</option>
      )
    }
  }

  renderError() {
    if (this.props.error) {
      return (
        <div className="uk-text-danger">{ this.props.error[0] }</div>
      )
    }
  }
  renderLabel() {
    return(
      <label className="uk-form-label" htmlFor={this.props.name}>
        { this.renderRequired() }
        { " " + this.props.label }
      </label>
    )
  }
  renderRequired() {
    if (this.props.required) {
      return(
        <abbr title="required">*</abbr>
      )
    }
  }
}
export default FormWizard
